import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import { useSelector } from 'react-redux';
import useFormValidation from '../../../hooks/zodFormValidation';
import appSchema from '../../../schema/appSchema';
import { getMaskPhone, getMaskZip } from '../../../Utilities/Utilities';
import Button from '../../Button';

function AddEditReferralFacilityPopup({
  onClose,
  typeState,
  onReload,
  editPopup,
}) {
  const { user } = useSelector((store) => store.auth);

  const [data, setData] = useState('');
  const [formData, setFormData] = useState({
    id: '',
    facility_name: '',
    Specialty: '',
    address_1: '',
    city: '',
    state: '',
    zip: '',
    email: '',
    phone_l: '',
    phone_m: '',
    fax: '',
    note: '',
  });
  const [isSubmit, setSubmit] = useState(false);

  const { errors, validateForm } = useFormValidation({
    schema: appSchema.referralFacilitySchema(typeState === 5),
    formData: formData,
    isSubmit,
  });

  useEffect(() => {
    (async () => {
      try {
        let type;
        if (typeState === 3) type = 'facility';
        else if (typeState === 5) type = 'otherFacility';
        const response = await post('api/commonTask/openAddEditMasterPopup', {
          facilityId: editPopup?.referringMasterId,
          popUpType: type,
        });
        if (response.status === 200) {
          setData(response.data);
          const master = response.data.facilityMaster[0];
          setFormData({
            id: master?.id || '',
            facility_name: master?.facility_name || '',
            Specialty: master?.Specialty || '',
            address_1: master?.address_1 || '',
            city: master?.city || '',
            state: master?.state || '',
            zip: getMaskZip(master?.zip || ''),
            email: master?.email || '',
            phone_l: getMaskPhone(master?.phone_l || ''),
            phone_m: getMaskPhone(master?.phone_m || ''),
            fax: getMaskPhone(master?.fax || ''),
            note: master?.note || '',
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [editPopup, typeState]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone_l' || name === 'phone_m' || name === 'fax') {
      setFormData({ ...formData, [name]: getMaskPhone(value) });
    } else if (name === 'zip') {
      setFormData({ ...formData, [name]: getMaskZip(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const onSaveUpdate = async () => {
    setSubmit(true);
    const validationError = validateForm();
    if (validationError) return;

    try {
      let facilityType;
      if (typeState === 3) facilityType = '1';
      else if (typeState === 5) facilityType = '4';
      const response = await post('api/commonTask/saveUpdateFacilityMaster', {
        userId: user?.id,
        facilityId: editPopup?.referringMasterId || '',
        facilityType: facilityType,
        ...formData,
      });
      if (response.status === 200) {
        setUiMessage(
          'suc',
          typeState === 3
            ? 'Facility Added Successfully.'
            : 'Recipient Added Successfully.',
        );
        onReload();
        onClose();
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="openReferringProviderPopup">
        {/* HEADER */}
        <div className="addressBookHeader flex justify-between items-center">
          <span className="addressTitle">
            <h2>
              {typeState === 3 && 'Update Facility'}
              {typeState === 5 && 'Update Recipient'}
            </h2>
          </span>
          <Button className="addressClose" variant="circle" onClick={onClose}>
            X
          </Button>
        </div>

        {/* BODY */}
        <div className="addressBody">
          {/* FIRST ROW: NAME & SPECIALTY */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Facility Name *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="facility_name"
                  value={formData.facility_name}
                  placeholder="Facility Name"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.facility_name && errors?.facility_name?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Type/Specialty</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="Specialty"
                  value={formData.Specialty}
                  placeholder="eg, General Hospital, Imaging Center"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.Specialty && errors?.Specialty?.message}
                </p>
              </div>
            </div>
          </div>

          {/* STREET ADDRESS */}
          <div className="addressBodyRow">Street Address</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh h-8"
              type="text"
              name="address_1"
              value={formData.address_1}
              placeholder="Street Address"
              onChange={handleChange}
            />
            <p className="error-msg">
              {errors?.address_1 && errors?.address_1?.message}
            </p>
          </div>

          {/* CITY / STATE / ZIP */}
          <div className="addressBodyRow">
            {/* CITY */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">City</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="city"
                  value={formData.city}
                  placeholder="City"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.city && errors?.city?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* STATE */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">State</div>
              <div className="addressBodyRow">
                <select
                  id="facilityState"
                  className="chzn-select addressBookSearh h-8"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.stateMaster?.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.stateName}
                    </option>
                  ))}
                </select>
                <p className="error-msg">
                  {errors?.state && errors?.state?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* ZIP */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">ZIP Code *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="zip"
                  value={formData.zip}
                  placeholder="Zip"
                  maxLength="10"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.zip && errors?.zip?.message}
                </p>
              </div>
            </div>
          </div>

          {/* EMAIL */}
          <div className="addressBodyRow">Email</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh h-8"
              type="text"
              name="email"
              value={formData.email}
              placeholder="Email address"
              onChange={handleChange}
            />
            <p className="error-msg">
              {errors?.email && errors?.email?.message}
            </p>
          </div>

          {/* PHONES */}
          <div className="addressBodyRow">
            {/* DESK PHONE */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Desk Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="phone_l"
                  value={formData.phone_l}
                  placeholder="(000) 000-0000"
                  maxLength="14"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.phone_l && errors?.phone_l?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* CELL */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Cell Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="phone_m"
                  value={formData.phone_m}
                  placeholder="(000) 000-0000"
                  maxLength="14"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.phone_m && errors?.phone_m?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            {/* FAX */}
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Fax *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="fax"
                  value={formData.fax}
                  placeholder="(000) 000-0000"
                  maxLength="14"
                  onChange={handleChange}
                />
                <p className="error-msg">
                  {errors?.fax && errors?.fax?.message}
                </p>
              </div>
            </div>
          </div>

          {/* NOTE */}
          <div className="addressBodyRow">Note</div>
          <div className="addressBodyRow">
            <textarea
              className="addressBookSearh h-8"
              name="note"
              placeholder="Additional notes or special instructions"
              rows="3"
              value={formData.note}
              onChange={handleChange}
            ></textarea>
          </div>

          {/* BUTTONS */}
          <div className="addressBodyRow flex gap-2 justify-end">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSaveUpdate}>
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEditReferralFacilityPopup;
